import * as ActionType from "./claimRequest.type";

const initialState = {
  claims: [],
};

export const claimRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_CLAIM_REQUESTS:
      return { ...state, claims: action.payload };
    case ActionType.UPDATE_CLAIM_REQUEST_STATUS:
      return {
        ...state,
        claims: state.claims.map((c) =>
          c._id === action.payload.id ? { ...c, status: action.payload.status } : c
        ),
      };
    default:
      return state;
  }
};
